import { accordion } from './accordion.js';
import { anchorScroll } from './anchorScroll.js';
import { articleProgress } from './articleProgress.js';
import { blogFilter } from './blogFilter.js';
import { cardAnimate } from './cardAnimate.js';
import { contactModal } from './contactModal.js';
import { drawLine } from './drawLine.js';
import { footerWatermark } from './footer.js';
import { greeting } from './greeting.js';
import { header } from './header.js';
import { headingUpdate } from './headingUpdate.js';
import { lenisScroll } from './lenis.js';
import { parallaxImage } from './parallaxImage.js';
import { quoteAnimate } from './quoteAnimate.js';
import { scrollProgress } from './scrollProgress.js';
import { textReveal } from './textReveal.js';
import { textFill } from './textFill.js';
import { frontHero } from './frontHero.js';
import { accordionAnimate} from './cardAnimate.js';




export function runModules() {
  // GSAP / ScrollTrigger gerelateerde modules
  textFill();
  textReveal();

  // Page-level modules (binnen Barba container)
  accordion();
  anchorScroll();
  articleProgress();
  blogFilter();
  cardAnimate();
  contactModal();
  drawLine();
  greeting();
  headingUpdate();
  parallaxImage();
  quoteAnimate();
  scrollProgress();
  header();
  footerWatermark();
  lenisScroll();
  frontHero();
  accordionAnimate();





  ScrollTrigger.refresh(true);
  console.log('✅ runModules() loaded');
}
